import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '../account/Currency';

@Pipe({
  name: 'formatCurrency',
  standalone: false,
})
export class FormatCurrencyPipe implements PipeTransform {
  transform(value: number, currency: Currency | string | undefined): string {
    const { symbol, suffix } = FormatCurrencyPipe.resolveSymbol(currency);
    const formatted =
      value == null || isNaN(value)
        ? '0.00'
        : value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return suffix ? `${formatted} ${symbol}` : `${symbol}${formatted}`;
  }

  static resolveSymbol(currency: Currency | string | undefined): { symbol: string; suffix: boolean } {
    const s = (sym: string, suffix = false) => ({ symbol: sym, suffix });
    switch (currency) {
      case Currency.Eur:
        return s('€');
      case Currency.Usd:
        return s('$');
      case Currency.Gbp:
        return s('£');
      case Currency.Jpy:
        return s('¥');
      case Currency.Cny:
        return s('¥');
      case Currency.Inr:
        return s('₹');
      case Currency.Krw:
        return s('₩');
      case Currency.Try:
        return s('₺');
      case Currency.Rub:
        return s('₽');
      case Currency.Brl:
        return s('R$');
      case Currency.Sek:
        return s('kr', true);
      case Currency.Nok:
        return s('kr', true);
      case Currency.Dkk:
        return s('kr', true);
      case Currency.Chf:
        return s('CHF', true);
      case Currency.Cad:
        return s('CA$');
      case Currency.Aud:
        return s('A$');
      case Currency.Hkd:
        return s('HK$');
      case Currency.Sgd:
        return s('S$');
      case Currency.Nzd:
        return s('NZ$');
      case Currency.Zar:
        return s('R');
      case Currency.Mxn:
        return s('$');
      case Currency.Pln:
        return s('zł', true);
      default:
        return s('');
    }
  }
}
